import { ASSET_DIR, STRINGS } from '@/constants/agriOutput'
import styles from '@/styles/OurBrand.module.css'

import Picture from '../picture'

interface ButtonProps {
  href: string
  label: string
}

const Button = ({ href, label }: ButtonProps) => (
  <a
    href={href}
    className={`my-4 bg-dehaat-green text-base py-[8.4px] px-[21.4px] rounded-full text-white inline-block ${styles.knowMore}`}
  >
    {label}
  </a>
)

const OurBrand = () => (
  <>
    <h2 className="text-black mt-4 text-3xl font-natosans-medium">
      {STRINGS.OUR_BRAND}
    </h2>
    <section className="flex">
      <article className="md:w-1/2">
        <Picture
          image={`${ASSET_DIR}/farmplus-logo`}
          imageAlt="Farmplus logo"
          imageStyle="w-32 h-[62px]"
          pictureStyle="my-4 block"
        />
        <p className="whitespace-pre-wrap mb-2.5 text-footer-grey text-base pt-4 font-natosans-light">
          {STRINGS.BRAND_DESCRIPTION}
        </p>
        <Button
          href="https://farmplus.agrevolution.in"
          label={STRINGS.KNOW_MORE}
        />
      </article>
      <article className="md:flex items-center md:w-1/2 hidden relative">
        <Picture
          image={`${ASSET_DIR}/farmplus`}
          imageAlt="Rack full of fresh vegetables and fruits"
          imageStyle="h-full"
          pictureStyle="absolute flex justify-center items-center w-full h-full"
        />
      </article>
    </section>
  </>
)

export default OurBrand
